import * as React from 'react';
import styled from 'styled-components';

export const Container = styled.label`
  display: flex;
  position: relative;
  align-items: center;
  padding-bottom: 5px;
`;

const FloatingBadge = styled.div`
  position: absolute;
  top: -5px;
  right: -12px;
  padding: 2px;
  padding-top: 5px;
  height: 15px;
  width: 15px;
  border-radius: 50%;
  background-color: red;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: .7em;
  font-weight: bold;
  font-family: 'Roboto';
`;

interface IProps {
  children: React.ReactNode;
  badgeContent?: string;
  id?: string;
  style?: React.CSSProperties;
}

export const ControlLabel = (props: IProps): React.ReactElement => {
  return (
    <Container style={props.style}>
      {props.badgeContent && (
        <FloatingBadge>
          <span style={{ flex: 1 }}>{props.badgeContent}</span>
        </FloatingBadge>
      )}
      {props.children}
    </Container>
  );
};
